import * as S from './styled';
import React, { useEffect, useState, useRef } from 'react';
import { useAppSelector } from '../../../../../../../redux/store';
import {
  setProduct,
  setProducts,
  addProductTable,
  addProductTableComments,
  addProductTableEdges,
  addProductTableExtras,
  setPrice,
} from '../../../../../../../redux/features/product/product-slice';
import DataTable from 'react-data-table-component';
import tableStyleDefault from '../../../../../../../Services/tableStyleDefault';
import { paginationOptions } from '../../../../../../data/PagineteInfo';
import CustomLoader from '../../../../../../data/customLoader';
import { IProduct } from '../../../../../../../redux/features/product/interface';
import { Footer } from '../../Footer';
import { IActivedTab } from '../../index';
import { notifyError, notifyWarning, notify } from '../../../../../../notify/notify-component';
import { FaSearch, FaTimes, FaFilter, FaCheckCircle } from 'react-icons/fa';

interface IProps {
  show: boolean;
  handleClose: () => void;
  dispatch?: any;
  storeId?: number;
  activedtab: IActivedTab;
}

const PAGE_SIZE = 15;

export function ModalProducts({
  show,
  handleClose,
  dispatch,
  storeId,
  activedtab,
}: IProps) {
  const { loading, product, flavors, edges, extras, comments, allProducts } =
  useAppSelector(({ productReducer }) => productReducer.value);

console.log('🧩 [ModalProducts] allProducts:', allProducts);
console.log('🧩 [ModalProducts] allProducts.length:', allProducts?.length);
console.log('🧩 [ModalProducts] loading:', loading);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState<IProduct[]>([]);
  const [productSearch, setProductSearch] = useState('');
  const searchInputRef = useRef<HTMLInputElement>(null);

  // Filtragem local — instantânea, sem debounce
  const filteredProducts = React.useMemo(() => {
    const list = allProducts ?? [];
    const term = productSearch.trim().toLowerCase();
    if (!term) return list;
    return list.filter(
      (p: IProduct) =>
        p.sale_name?.toLowerCase().includes(term) ||
        p.id_pdv?.toString().includes(term)
    );
  }, [allProducts, productSearch]);

  // Paginação manual sobre a lista filtrada
  const totalResults = filteredProducts.length;
  const paginatedData = filteredProducts.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const handlePageChange = (page: number) => setCurrentPage(page);

  const handleRowsSelected = (state: { selectedRows: IProduct[] }) => {
    setSelectedRows(state.selectedRows);
  };

  const handleClearSearch = () => {
    setProductSearch('');
    setCurrentPage(1);
    searchInputRef.current?.focus();
  };

  const handleCancelAdd = () => {
    dispatch(setProduct([]));
    dispatch(setProducts({ data: [] }));
    handleClearSearch();
    setSelectedRows([]);
    handleClose();
  };

  // Reset ao abrir + auto-focus
  useEffect(() => {
    if (show) {
      setProductSearch('');
      setCurrentPage(1);
      setSelectedRows([]);
      setTimeout(() => searchInputRef.current?.focus(), 100);
    }
  }, [show]);

  // Reset página ao mudar o filtro
  useEffect(() => {
    setCurrentPage(1);
  }, [productSearch]);

  // Atalhos de teclado
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && productSearch) handleClearSearch();
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };
    if (show) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [show, productSearch]);

  const handleSelectProducts = () => {
    if (selectedRows.length === 0) {
      notifyWarning('Nenhum produto selecionado!');
      return;
    }

    let addedCount = 0;
    let skippedCount = 0;
    const skippedNames: string[] = [];

    selectedRows.forEach((prod: IProduct) => {
      const productName = prod.sale_name;

      if (activedtab.sabores) {
        const hasProduct = flavors.find(
          (item: any) => item?.ItemKeyId === prod?.id_pdv?.toString()
        );
        if (hasProduct) { skippedCount++; skippedNames.push(productName); return; }
        dispatch(addProductTable({
          ...prod,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.sale_name,
          Price: prod?.sale_price,
          sale_price: prod?.sale_price,
          Type: 1,
        }));
        addedCount++;
      }

      if (activedtab.borda) {
        const hasProduct = edges.find(
          (item: any) => item?.ItemKeyId === prod?.id_pdv?.toString()
        );
        if (hasProduct) { skippedCount++; skippedNames.push(productName); return; }
        dispatch(addProductTableEdges({
          ...prod,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.sale_name,
          Price: prod?.sale_price,
          sale_price: prod?.sale_price,
          Type: 2,
        }));
        addedCount++;
      }

      if (activedtab.extra) {
        const hasProduct = extras.find(
          (item: any) => item?.ItemKeyId === prod?.id_pdv?.toString()
        );
        if (hasProduct) { skippedCount++; skippedNames.push(productName); return; }
        dispatch(addProductTableExtras({
          ...prod,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.sale_name,
          Price: prod?.sale_price,
          sale_price: prod?.sale_price,
          Type: 3,
        }));
        addedCount++;
      }

      if (activedtab.comentario) {
        const hasProduct = comments.find(
          (item: any) => item?.ItemKeyId === prod?.id_pdv?.toString()
        );
        if (hasProduct) { skippedCount++; skippedNames.push(productName); return; }
        dispatch(addProductTableComments({
          ...prod,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.sale_name,
          Price: prod?.sale_price,
          sale_price: prod?.sale_price,
          Type: 4,
        }));
        addedCount++;
      }
    });

    if (addedCount > 0) {
      notify(addedCount === 1 ? '✓ 1 produto adicionado!' : `✓ ${addedCount} produtos adicionados!`);
    }
    if (skippedCount > 0) {
      if (addedCount === 0) {
        notifyError(`Todos já cadastrados: ${skippedNames.join(', ')}`);
      } else {
        notifyWarning(
          `${skippedCount} já cadastrado(s): ${skippedNames.slice(0, 3).join(', ')}${skippedCount > 3 ? '...' : ''}`
        );
      }
    }

    dispatch(setProduct([]));
    dispatch(setPrice(undefined));
    setSelectedRows([]);
    handleClose();
  };

  const columns: any = [
    {
      name: 'Código',
      sortable: true,
      width: '88px',
      center: true,
      selector: (row: IProduct) => row?.id_pdv,
    },
    {
      name: 'Produto',
      minWidth: '190px',
      sortable: true,
      selector: (row: IProduct) => row?.sale_name?.toUpperCase(),
      cell: (row: IProduct) => (
        <div style={{ padding: '8px 0' }}>
          <div style={{ fontWeight: '500' }}>{row?.sale_name}</div>
          {row?.relationships?.category?.name && (
            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
              {row?.relationships?.category?.name}
            </div>
          )}
        </div>
      ),
    },
    {
      name: 'Preço',
      selector: (row: IProduct) =>
        row?.sale_price?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
      width: '100px',
      center: true,
      sortable: true,
      cell: (row: IProduct) => (
        <div style={{ fontWeight: '600', color: '#28a745' }}>
          {row?.sale_price?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </div>
      ),
    },
  ];

  return (
    <S.ModalFamily show={show} onHide={handleCancelAdd} centered size="lg">
      <S.Container>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
        }}>
          <h2 style={{ margin: 0 }}>Importar Produto</h2>
          <div style={{ fontSize: '13px', color: '#666' }}>
            {(allProducts?.length ?? 0) > 0 && (
              <span><strong>{allProducts.length}</strong> produto(s) disponível(is)</span>
            )}
          </div>
        </div>

        <S.Wrapper>
          {/* Campo de Pesquisa */}
          <div style={{ position: 'relative', marginBottom: '15px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 15px',
              border: '2px solid #e0e0e0',
              borderRadius: '8px',
              backgroundColor: '#fff',
              boxShadow: productSearch ? '0 2px 8px rgba(0,123,255,0.15)' : 'none',
            }}>
              <FaSearch size={16} color="#999" />
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Pesquisar por nome ou código... (Ctrl+K)"
                value={productSearch}
                onChange={(e) => setProductSearch(e.target.value)}
                style={{ flex: 1, border: 'none', outline: 'none', fontSize: '14px', padding: '5px 0' }}
              />
              {productSearch && (
                <button
                  type="button"
                  onClick={handleClearSearch}
                  style={{
                    background: '#f0f0f0',
                    border: 'none',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <FaTimes size={12} color="#666" />
                </button>
              )}
            </div>
          </div>

          {/* Indicadores */}
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
            {productSearch && (
              <div style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: '#e3f2fd', color: '#1976d2',
                borderRadius: '20px', fontWeight: '500',
                display: 'flex', alignItems: 'center', gap: '6px',
              }}>
                <FaFilter size={11} />
                Filtrando: <strong>{productSearch}</strong>
              </div>
            )}
            {totalResults > 0 && (
              <div style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: '#f1f8e9', color: '#558b2f',
                borderRadius: '20px', fontWeight: '500',
              }}>
                {totalResults} resultado(s)
              </div>
            )}
            {selectedRows.length > 0 && (
              <div style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: '#fff3e0', color: '#f57c00',
                borderRadius: '20px', fontWeight: '500',
                display: 'flex', alignItems: 'center', gap: '6px',
              }}>
                <FaCheckCircle size={11} />
                {selectedRows.length} selecionado(s)
              </div>
            )}
          </div>

          {/* Tabela */}
          <div style={{
            overflowX: 'auto', height: '480px',
            border: '1px solid #e0e0e0', borderRadius: '8px',
          }}>
            <DataTable
              columns={columns}
              data={paginatedData}
              striped
              pagination
              paginationServer
              paginationTotalRows={totalResults}
              paginationDefaultPage={currentPage}
              paginationPerPage={PAGE_SIZE}
              onChangePage={handlePageChange}
              customStyles={{
                ...tableStyleDefault,
                rows: {
                  style: { '&:hover': { backgroundColor: '#f8f9fa', cursor: 'pointer' } },
                },
              }}
              selectableRows
              selectableRowsHighlight
              onSelectedRowsChange={handleRowsSelected}
              clearSelectedRows={!show}
              paginationComponentOptions={paginationOptions}
              progressPending={loading}
              progressComponent={<CustomLoader />}
              noDataComponent={
                <div style={{ padding: '40px', textAlign: 'center' }}>
                  {productSearch ? (
                    <>
                      <FaSearch size={32} color="#ccc" style={{ marginBottom: '10px' }} />
                      <div style={{ fontSize: '14px', color: '#666' }}>
                        Nenhum resultado para <strong>"{productSearch}"</strong>
                      </div>
                      <button
                        onClick={handleClearSearch}
                        style={{
                          marginTop: '15px', padding: '8px 16px',
                          backgroundColor: '#007bff', color: 'white',
                          border: 'none', borderRadius: '4px',
                          cursor: 'pointer', fontSize: '13px',
                        }}
                      >
                        Limpar Pesquisa
                      </button>
                    </>
                  ) : (
                    <div style={{ fontSize: '14px', color: '#999' }}>Nenhum produto disponível</div>
                  )}
                </div>
              }
            />
          </div>

          <div style={{ marginTop: '12px', fontSize: '11px', color: '#999', display: 'flex', gap: '15px' }}>
            <span><kbd>Ctrl+K</kbd> Focar pesquisa</span>
            <span><kbd>ESC</kbd> Limpar pesquisa</span>
          </div>
        </S.Wrapper>
      </S.Container>

      <Footer
        handleClose={handleCancelAdd}
        text2="Cancelar"
        text1={`Adicionar${selectedRows.length > 0 ? ` (${selectedRows.length})` : ''}`}
        handleAction={handleSelectProducts}
      />

      <style>{`
        kbd {
          padding: 2px 6px;
          background: #f5f5f5;
          border: 1px solid #ccc;
          border-radius: 3px;
          font-size: 10px;
          font-family: monospace;
        }
      `}</style>
    </S.ModalFamily>
  );
}